import { FC } from 'react';
import clsx from 'clsx';
import { Iframe } from '@alf/uikit';
import PandascoreTabs from './common/PandascoreTabs';
import usePandascore from './hooks/usePandascore';

import styles from './index.module.css';

export const Pandascore: FC<{ src: string; className?: string }> = ({
  src,
  className
}) => {
  const { isShowPandascoreTabs, url, selectedTab, handleSelectTab } =
    usePandascore(src);

  if (!src || !URL.canParse(src, window.location.origin)) {
    return null;
  }

  return (
    <>
      <Iframe
        key={url}
        data-role="pandascore-iframe"
        title="pandascore-iframe"
        src={url}
        className={clsx(styles.container, className)}
      />
      {isShowPandascoreTabs && (
        <PandascoreTabs
          selectedTab={selectedTab}
          handleSelectTab={handleSelectTab}
        />
      )}
    </>
  );
};
